import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  checkBox: {
    fontFamily: "$option_icon_style",
    color: "$selected_option",
    backgroundColor: "$option_text",
  },
  chechBoxContainer: {
    backgroundColor: "transparent",
    borderWidth: 0,
  },
  radioBox: {
    backgroundColor: "$table_text",
  },
  wrapperStyleSVG: {
    paddingLeft: "15px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  textview: {
    flex: 1,
    flexGrow: 1,
  },
  textInput: {
    backgroundColor: "$question_text",
  },
  text: {
    color: "$option_text",
    fontWeight: "normal",
    flexWrap: "wrap",
    fontSize: "$option_text_size",
    fontFamily: "$option_text_style",
    paddingLeft: 10,
    paddingRight: 10,
  },
  correctText: {
    color: "$correct",
  },
  incorrectText: {
    color: "$incorrect",
  },
});
